// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"206":"f155e544","263":"4d0441f1","354":"2372b6b7","682":"337b1a99","765":"3542c02f","864":"d74fd435"}[chunkId] + ".css";
};